export default "__VITE_ASSET__D9yv3bSN__"